module.exports = __webpack_public_path__ + "img/img-event.01d7e213.jpg";